import Cookies from 'js-cookie';
import { APP_NAME } from '@libs/constants';

export const nextApiCall = async <T>(path: string, body: T, method?: string): Promise<Response> =>
  fetch(`/_${APP_NAME}/api/${path}`, {
    method: method ?? 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN') || '',
    }),
    body: JSON.stringify(body),
  });
